import "./SocialProof.scss";

const quotes = [
  "Easy to learn but surprisingly strategic.",
  "The surrounding influence mechanic is brilliant.",
  "I wanted to play again immediately."
];

export default function SocialProof() {
  return (
    <section
      className="social section"
      style={{ "--playtested-image": "url('/assets/images/playtested.webp')" }}
    >
      <div className="section-header">
        <span className="section-eyebrow">Playtested by 200+ Gamers</span>
        <h2 className="section-title">Refined Through Real Table Feedback.</h2>
        <p className="section-copy">
          Kotam: Conquest has been tested with gamers at conventions, local playtests, and live demos to make the game quick to teach, engaging to play, and satisfying to revisit.
        </p>
      </div>

      <div className="social__layout">
        <div className="card">
          <div className="social__photo">

          </div>
          {/* <div className="image-placeholder">
            <div>
              <strong>Origins / Booth Photo</strong>
              <small>Replace: origins-photo.webp</small>
            </div>
          </div> */}
        </div>

        <div className="social__quotes">
          {quotes.map((quote) => (
            <article className="social__quote card" key={quote}>
              <div className="social__stars">★★★★★</div>
              <p>“{quote}”</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
